export const isNumber = (num) => {
  const regex = /^\d+$/;
  return regex.test(num);
};

export const isAlphabet = (str) => {
  const regex = /^[a-zA-Z]+$/;
  return regex.test(str);
};
